/*
 * Reassurance badges — comportamiento dinamico.
 *
 * <reassurance-estimate>  : calcula rangos de fecha de entrega (Lima / provincia)
 *                            sumando dias habiles a "hoy", estilo mush.pe.
 * <reassurance-cuotas>     : recalcula el monto de la cuota (precio / n cuotas)
 *                            y se actualiza al cambiar de variante (PUB_SUB variantChange).
 *
 * Sin dependencias nuevas: reusa los globales `subscribe` y `PUB_SUB_EVENTS`
 * del tema (assets/global.js + pubsub.js).
 */
(function () {
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay(); // 0 dom, 6 sab
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function fmtRange(d1, d2) {
    if (d1.getTime() === d2.getTime()) {
      return d1.getDate() + ' ' + MESES[d1.getMonth()];
    }
    if (d1.getMonth() === d2.getMonth()) {
      return d1.getDate() + '–' + d2.getDate() + ' ' + MESES[d1.getMonth()];
    }
    return d1.getDate() + ' ' + MESES[d1.getMonth()] + ' – ' + d2.getDate() + ' ' + MESES[d2.getMonth()];
  }

  function rangeText(minDays, maxDays) {
    var today = new Date();
    var d1 = addBusinessDays(today, minDays);
    var d2 = addBusinessDays(today, maxDays);
    return fmtRange(d1, d2);
  }

  if (!customElements.get('reassurance-estimate')) {
    customElements.define('reassurance-estimate', class extends HTMLElement {
      connectedCallback() {
        this.render();
      }
      render() {
        var lima = this.querySelector('.js-entrega-lima');
        var prov = this.querySelector('.js-entrega-prov');
        if (lima) {
          lima.textContent = rangeText(
            parseInt(this.dataset.limaMin || '1', 10),
            parseInt(this.dataset.limaMax || '2', 10)
          );
        }
        if (prov) {
          prov.textContent = rangeText(
            parseInt(this.dataset.provMin || '3', 10),
            parseInt(this.dataset.provMax || '5', 10)
          );
        }
      }
    });
  }

  // --- Formateo de dinero (Shopify.formatMoney portado, soporta {{amount}} y variantes) ---
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(num, precision) {
      if (isNaN(num)) num = 0;
      num = (num / 100).toFixed(precision);
      return num;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  if (!customElements.get('reassurance-cuotas')) {
    customElements.define('reassurance-cuotas', class extends HTMLElement {
      connectedCallback() {
        this.amountEl = this.querySelector('.js-cuota-amount');
        this.sectionId = this.dataset.sectionId;
        this.count = parseInt(this.dataset.cuotasCount || '3', 10);
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant.bind(this));
        }
      }
      disconnectedCallback() {
        if (this.unsub) this.unsub();
      }
      onVariant(event) {
        if (!event || !event.data || !event.data.variant) return;
        if (this.sectionId && event.data.sectionId && event.data.sectionId !== this.sectionId) return;
        var price = event.data.variant.price; // centavos
        if (price == null || !this.amountEl || !this.count) return;
        var per = Math.round(price / this.count);
        this.amountEl.textContent = formatMoney(per, this.moneyFormat);
      }
    });
  }
})();
